"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    body: 'Please contact your system administrator for details.',
    header: 'Your Organization has been Deactivated'
};
